{
  "siteTitle": "Beheerdersportaal",
  "titles": {
    "confirmationDialog": "Weet je het zeker?",
    "resetMfa": "Heb je de identiteit gecontroleerd?"
  },
  "actions": {
    "search": "Zoeken",
    "view": "Bekijken",
    "add": "Toevoegen",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "save": "Opslaan",
    "continue": "Doorgaan",
    "submit": "Indienen",
    "apply": "Toepassen",
    "loadMore": "Meer laden",
    "next": "Volgende",
    "previous": "Vorige",
    "pin": "Vastzetten",
    "unpin": "Losmaken",
    "resetMfa": "MFA resetten",
    "logout": "Uitloggen",
    "delete": "Verwijderen",
    "confirm": "Bevestigen"
  },
  "errors": {
    "titles": {
      "401": "Niet geautoriseerd",
      "404": "Niet gevonden",
      "403": "Geen toegang",
      "500": "Er ging iets mis",
      "502": "Er ging iets mis",
      "unknown": "Er ging iets mis",
      "422": "Er ging iets mis",
      "429": "Te veel verzoeken",
      "network": "Netwerkfout"
    },
    "messages": {
      "401": "Er is iets misgegaan met je authenticatie. Probeer opnieuw in te loggen.",
      "404": "Niet gevonden",
      "403": "Je hebt geen toegang tot dit onderdeel.",
      "500": "Er ging iets onbekends mis",
      "502": "Er is iets misgegaan met de server, probeer het later opnieuw.",
      "unknown": "Er ging iets onbekends mis",
      "422": "Je hebt iets niet juist ingevuld.",
      "429": "Je hebt te veel verzoeken gedaan. Probeer het opnieuw over {seconds} seconden.",
      "network": "Er is een netwerkfout opgetreden. Dit betekent waarschijnlijk dat je geen verbinding hebt met het internet, probeer het later opnieuw.",
      "mfaResetFailed": "MFA resetten is mislukt"
    },
    "validation": {
      "mongoId": "{0} is verplicht",
      "required": "{0} is verplicht",
      "alpha": "{0} mag alleen letters bevatten",
      "equals": "{0} moet gelijk zijn aan {1}",
      "notEquals": "{0} mag niet gelijk zijn aan {1}",
      "empty": "{0} moet leeg zijn",
      "notEmpty": "{0} mag niet leeg zijn",
      "in": "{0} moet een van de volgende waarden zijn: {1}",
      "notIn": "{0} mag niet een van de volgende waarden zijn: {1}",
      "boolean": "{0} moet een ja of nee zijn",
      "date": "{0} is verplicht",
      "string": "{0} is verplicht",
      "number": "{0} is verplicht",
      "int": "{0} moet een geheel getal zijn",
      "array": "{0} moet een lijst zijn",
      "enum": "{0} moet een van de volgende waarden zijn: {1}",
      "divisibleBy": "{0} moet deelbaar zijn door {1}",
      "positive": "{0} moet positief zijn",
      "negative": "{0} moet negatief zijn",
      "min": "{0} mag niet kleiner zijn dan {1}",
      "minLength": "{0} moet langer zijn dan {1} karakter",
      "maxLength": "{0} mag niet langer zijn dan {1} tekens",
      "max": "{0} mag niet groter zijn dan {1}",
      "length": "{0} moet exact {1} tekens lang zijn",
      "minDate": "{0} moet vanaf {1} zijn",
      "maxDate": "{0} moet uiterlijk {1} zijn",
      "booleanString": "{0} moet een tekstuele waarde van ja of nee zijn",
      "dateString": "{0} is verplicht",
      "numberString": "{0} mag enkel uit nummers bestaan",
      "iBAN": "{0} is geen geldig IBAN nummer",
      "email": "{0} is geen geldig e-mailadres",
      "phoneNumber": "{0} is geen geldig telefoonnummer",
      "strongPassword": "{0} moet een sterk wachtwoord zijn",
      "postalCode": "Dit is geen geldige postcode",
      "unique": "{0} is al in gebruik",
      "before": "{0} moet voor {1} zijn",
      "pattern": "{0} voldoet niet aan het patroon",
      "bIC": "{0} is geen geldig BIC nummer",
      "personName": "{0} is geen geldige naam",
      "inArray": "{0} is niet toegestaan",
      "after": "{0} moet na {1} zijn",
      "linked-entities": "{0} mist een waarde die nodig is voor gekoppelde entiteiten",
      "true": "{0} moet aangekruist zijn"
    }
  },
  "messages": {
    "none": "geen",
    "welcome": "Welkom",
    "createdAtBy": "Aangemaakt op {date} door {name}",
    "updatedAtBy": "Laatst gewijzigd op {date} door {name}",
    "resetMfa": "Heb je gecontroleerd dat de gebruiker via een bekend kanaal contact heeft opgenomen (een bij ons bekend mailadres of telefoonnummer) \n\r \n\r Heb je de identiteit geverifieerd met iets wat niet publiek is? Voorkom dat DebitRoom het slachtoffer wordt van social engineering.",
    "mfaResetSuccess": "MFA is gereset",
    "noRole": "Je hebt niet de juiste rol om de manage omgeving te mogen bezoeken. \n\r Het zou kunnen zijn dat je intussen in een ander platform van DebitRoom bent ingelogd met een andere gebruiker. Probeer uit te loggen en opnieuw in te loggen met de juiste gebruiker.",
    "noData": "Geen gegevens om weer te geven"
  },
  "fields": {
    "labels": {
      "address": {
        "street": "Straat",
        "houseNumber": "Huisnr",
        "postalCode": "Postcode",
        "city": "Plaats",
        "country": "Land"
      }
    }
  },
  "labels": {
    "actions": "Acties",
    "environments": {
      "localhost": "lokaal",
      "test": "test",
      "accept": "acceptatie",
      "production": "productie"
    }
  },
  "units": {
    "months": "{n} maand|{n} maanden",
    "years": "{n} jaar|{n} jaren",
    "days": "{n} dag|{n} dagen"
  },
  "and": "en",
  "unknown": "Onbekend",
  "at": "op"
}
